<template>
  <div class="animated fadeIn">
    <MainChartTable :set_data=set_data :selectedData=impression />
  </div>
</template>
<script>
import MainChartTable from '../MainChartTable'
export default {
    name: 'Impression',
    props:[ 'setData'],
    components:{
        MainChartTable
    },
    data () {
        return {
            set_data:0,
            impression:'impressions',
        }
    },
    watch :{
        setData(nValue,oValue){
            this.set_data++
            this.impression='impressions'
        }
    }
}
</script>
